export const baiduOCR = {
  // 以下为百度 ocr 识别新增配置
  baiduApi_grant_type: 'client_credentials', // 必须参数，固定为client_credentials
  baiduApi_client_id: 'dgl0XykfGXjQdMg2M2Wz9HgZ', // 必须参数，应用的API Key；
  baiduApi_client_secret: 'bnqRGvb9OGHtErGUwsa2qUGDYT0SKoKR' // 必须参数，应用的Secret Key；
}
